module.exports = {
    addToCart: item => {
        if (window.ga) {
            window.ga.getAll()[0].send(
                "event",
                "Подбор модификации",
                "Добавить в корзину",
                item
            )
        }
        if (window.ym) {
            window.ym(3419323, "reachGoal", "project2_buy");
        }
    },
    showBlock: item => {
        if (window.ga) {
            window.ga.getAll()[0].send(
                "event",
                "Подбор модификации",
                "Интерфейс фильтра",
                item
            )
        }
    },
    getTableData: () => {
        if (window.ga) {
            window.ga.getAll()[0].send(
                "event",
                "Подбор модификации",
                "Показать результат",
                "false"
            )
        }
        if (window.ym) {
            window.ym(3419323, "reachGoal", "project2_showRes")
        }
    },
    getPdf: () => {
        if (window.ga) {
            window.ga.getAll()[0].send("event", "Подбор модификации", "Скачать PDF", " ")
        }
        if (window.ym) {
            window.ym(3419323,'reachGoal','project2_pdf')
        }
    },
    getMail: (email) => {
        if (window.ga) {
            window.ga.getAll()[0].send("event", "Подбор модификации", "Отправить на email", email)
        }
        if (window.ym) {
            window.ym(3419323,'reachGoal','project2_email')
        }
    }
}